"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _CompletedContext = require("../CompletedContext");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var AudioPlayer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AudioPlayer, _Component);

  var _super = (0, _createSuper2.default)(AudioPlayer);

  function AudioPlayer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AudioPlayer);
    _this = _super.call(this, props);

    _this.pauseAllOthers = function (e) {
      var audios = document.getElementsByTagName('audio');

      for (var i = 0, len = audios.length; i < len; i++) {
        if (audios[i] !== e.target) {
          audios[i].pause();
        }
      }
    };

    _this.state = props.state || {};

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = _this.props.completed || false;
    }

    return _this;
  }

  (0, _createClass2.default)(AudioPlayer, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i]; // Keep our stored state synchronized

        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      document.addEventListener('submit', this.pauseAllOthers, true);
      document.addEventListener('play', this.pauseAllOthers, true);
      console.log("task mount", this.state);
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        key: this.props.key,
        style: this.props.style || {
          textAlign: "center",
          width: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement("audio", {
        style: {
          width: "100%",
          margin: "20px 0px"
        },
        controls: true,
        controlsList: "nodownload",
        onEnded: function onEnded() {
          _this3.setState({
            completed: true
          });
        }
      }, /*#__PURE__*/_react.default.createElement("source", {
        src: this.props.src,
        type: "audio/mpeg"
      }), /*#__PURE__*/_react.default.createElement("track", {
        src: this.props.trackSource,
        default: true,
        kind: "captions",
        srcLang: "en"
      }), "Your browser does not support the audio element."));
    }
  }]);
  return AudioPlayer;
}(_react.Component);

exports.default = AudioPlayer;
AudioPlayer.contextType = _CompletedContext.CompletedContext;